import { Vue } from "vue-property-decorator";

export const DownloadService = new Vue({
  methods: {
    download(blob: Blob, filename: string) {
      const a = document.createElement("a");
      // IE
      if (window.navigator.msSaveOrOpenBlob) {
        a.onclick = evx => {
          window.navigator.msSaveOrOpenBlob(blob, filename);
          this.notify("Success", "Report successfully downloaded.", "success");
        };
        a.click();
      } else {
        // Chrome and safari
        a.href = URL.createObjectURL(blob);
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(a.href);
        this.notify("Success", "Report successfully downloaded.", "success");
      }
    },
    notify(title: string, message: string, type: any) {
      this.$notify({
        title,
        message,
        type,
      });
    },
  },
});
